<template>
  <div class="accordion govuk-accordion__section" :class="isOpen ? 'govuk-accordion__section--expanded' : ''">
    <div class="accordion__header js-enabled govuk-accordion__section-header">
      <button
        @click="toggleAccordion()"
        class="govuk-accordion__section-button"
        :aria-expanded="isOpen"
        :aria-controls="`collapse${_uid}`"
      >
        <slot class="govuk-accordion__section-heading" name="title" />
        <icon class="accordion__header__icon" v-if="!isOpen" icon="plus" />
        <icon class="accordion__header__icon" :class="isOpen ? 'accordion--active' : ''" v-if="isOpen" icon="minus" />
      </button>
    </div>
    <div class="govuk-accordion__section-content" v-if="isOpen" :id="`collapse${_uid}`">
      <slot name="content" />
    </div>
  </div>
</template>
    
    <script>
export default {
  name: "Accordion",
  props: {
    title: String,
    content: String,
    isOpenOnLoad: Boolean,
  },

  data() {
    return {
      isOpen: false,
    };
  },

  mounted() {
    this.checkLoadStatus();
  },

  methods: {
    toggleAccordion() {
      this.isOpen = !this.isOpen;
    },
    checkLoadStatus() {
      if (this.isOpenOnLoad) {
        this.isOpen = true;
      } else if (!this.isOpenOnLoad) {
        this.isOpen = false;
      }
    },
  },
};
</script>